import { ResponseSearchAccessDto, ResumeGraphDto, RowAccessDto } from "@/dtos";
import { Access, Applications } from "@/entities";
import { areDatesSame, getDatesBetweeen, parseToLocalDateFromUtc } from "@/helpers/utilities";
import { DatePickerRangeDto } from "@/ui/components/datepickers/interfaces/date-picker";
import { LineDataset } from "@/ui/components/graphs/line/interfaces/line-dataset.interface";


export const formatRowAccessDto = (access: Access[]): RowAccessDto[] => {
    return access.map((x) => {
        const row: RowAccessDto = {
            access_id: x.id,
            aplication: x.application.name,
            last_access_date: (x.last_access_date) ? parseToLocalDateFromUtc(x.last_access_date?.toString()) :
                parseToLocalDateFromUtc(x.created_at?.toString()),
            active: 'Conectado',
            is_active: true
        }
        return row;
    });
}

export const formatResumeAccess = (applications: Applications[], accessList: ResponseSearchAccessDto) => {
    return applications.map(app => {
        const total = accessList.access.filter(x => x.application_id == app.id).length;
        const backColor = app.color ?? '#37d1b3';
        const textColor = app.text_color ?? '#FFFFFF';
        const resume: ResumeGraphDto = {
            style: `background-color:${backColor}; color:${textColor}`,
            total: total,
            name: app.name
        }

        return resume;
    });
}

export const formatGraphLabelsAccess = (range: DatePickerRangeDto) => {
    if (range.from && range.to) {
        return getDatesBetweeen(range.from, range.to);
    }
    return [] as string[];
}

export const formatGraphDatasetsAccess = (labels: string[], accessList: ResponseSearchAccessDto, applications: Applications[]) => {
    const datasets: LineDataset[] = [];
    for (const application of applications) {
        const accessApp = accessList.access.filter(x => x.application_id == application.id);

        const data: number[] = [];
        for (const label of labels) {
            const amount = accessApp.filter(x => areDatesSame(x.start_date, label)).length;
            data.push(amount);
        }

        const dataset: LineDataset = {
            label: `Accesos ${application.name}`,
            data: data,
            fill: false,
            borderColor: application.color ?? '#37d1b3',
            tension: 0.1
        }
        datasets.push(dataset);
    }

    return datasets;
}